import processEvent from 'analytics/processEvent';
import anaConsts from 'analytics/constants';
import anaUtils from 'analytics/utils';

export const trackLinkClick = data => {
    processEvent.process(anaConsts.LINK_TRACKING_EVENT, { data });
};

export const trackPageLoad = data => {
    processEvent.process(anaConsts.ASYNC_PAGE_LOAD, { data });
};

export const trackSelectItem = eventData => {
    processEvent.process(anaConsts.SELECT_ITEM_EVENT, eventData);
};

export const trackEvent = (eventType, eventData, options) => {
    processEvent.process(eventType, eventData, options);
};

export const trackBOPISSelection = (data, isInStock, productData) => {
    data.availablePreferredForBopis = isInStock ? 'Yes' : 'No';
    digitalData.page.attributes.isAvailablePreferredStore = isInStock ? 'Yes' : 'No';
    data.actionInfo = anaConsts.EVENT_NAMES.BUY_ONLINE_AND_PICK_UP_RADIO_BUTTON_CLICK;

    if (productData?.currentSku?.isOutOfStock) {
        digitalData.page.attributes.outOfStock = `Yes - ${anaConsts.FULFILLMENT_TYPE.Pickup}`;
    }
};

export const trackSDDSelection = (data, isSDUBannerVisible, productData) => {
    if (isSDUBannerVisible) {
        data.linkName = anaConsts.EVENT_NAMES.SAME_DAY_DELIVERY_RADIO_BUTTON_CLICK;
        data.actionInfo = anaConsts.EVENT_NAMES.SAME_DAY_DELIVERY_RADIO_BUTTON_CLICK;
    }

    if (productData?.currentSku?.isOutOfStock) {
        digitalData.page.attributes.outOfStock = `Yes - ${anaConsts.FULFILLMENT_TYPE.Sameday}`;
    }

    data.eventStrings = [`${anaConsts.Event.EVENT_257}=${isSDUBannerVisible ? 1 : 0}`];
};

export const trackFulfillmentMethodChange = (method, sku, options = {}) => {
    const {
        preferredStoreId, customerZipCode, stockAvailability, isInStock, isSDUBannerVisible, productData
    } = options;

    digitalData.page.attributes.outOfStock = '';

    const data = {
        linkName: 'D=c55',
        actionInfo: 'Shipping Option',
        sku: { skuId: sku?.skuId },
        shippingMethod: method,
        preferredStoreId,
        customerZipCode,
        stockAvailability
    };

    if (method === anaConsts.DELIVERY_OPTIONS_MAP.Pickup) {
        trackBOPISSelection(data, isInStock, productData);
    }

    if (method === anaConsts.DELIVERY_OPTIONS_MAP.Sameday) {
        trackSDDSelection(data, isSDUBannerVisible, productData);
    }

    if (digitalData.page.attributes.outOfStock) {
        data.prop44 = digitalData.page.attributes.outOfStock;
    }

    processEvent.process(anaConsts.LINK_TRACKING_EVENT, { data });
};

const fireFrequencyModalTracking = (sku, linkData) => {
    const pageType = anaConsts.PAGE_TYPES.AUTO_REPLENISH;
    const pageDetail = anaConsts.PAGE_DETAIL.DELIVERY_FREQUENCY;
    const productStrings = anaUtils.buildSingleProductString({ sku });

    processEvent.process(anaConsts.ASYNC_PAGE_LOAD, {
        data: {
            pageName: `${pageType}:${pageDetail}:n/a:*`,
            pageType,
            pageDetail,
            linkData,
            productStrings
        }
    });
};

export const trackFrequencyModalOpen = sku => {
    fireFrequencyModalTracking(sku, anaConsts.LinkData.AUTO_REPLENISH_FREQUENCY_OPEN);
};

export const trackFrequencyModalClose = sku => {
    fireFrequencyModalTracking(sku, anaConsts.LinkData.AUTO_REPLENISH_FREQUENCY_CLOSE);
};

export const trackATBClick = (sku, qty, displayQuantityPickerInATB) => {
    const action = 'product:edit quantity';

    processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
        data: {
            actionInfo: action,
            linkName: action,
            eventStrings: [anaConsts.Event.EVENT_71],
            productStrings: [anaUtils.buildSingleProductString({ sku, isQuickLook: false, newProductQty: qty, displayQuantityPickerInATB })]
        }
    });
};

export const trackReviewFilterChange = filterSelections => {
    const actionLink = 'reviews:ratings&reviews-filter';

    processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
        data: {
            filterSelections,
            selectedFilter: filterSelections,
            actionInfo: actionLink,
            linkName: actionLink,
            eventStrings: [anaConsts.Event.EVENT_71]
        }
    });
};

export const trackSentimentSelect = sentiment => {
    processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
        data: { actionInfo: `reviews:sentiment:${sentiment}`, linkName: `reviews:sentiment:${sentiment}` }
    });
};

export const trackReviewPageChange = data => {
    processEvent.process(anaConsts.LINK_TRACKING_EVENT, { data });
};

export const trackSwatchSelect = typeSelected => {
    const actionText = `product:swatch:${typeSelected.toLowerCase()}`;

    processEvent.process(anaConsts.LINK_TRACKING_EVENT, {
        data: { actionInfo: actionText, linkName: actionText, eventStrings: [anaConsts.Event.EVENT_71] }
    });
};

export const trackRMNImpression = payload => {
    processEvent.process(anaConsts.LINK_TRACKING_EVENT, { data: payload });
};
